module.exports = __webpack_public_path__ + "static/img/download_bg_03.8a73fac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download_bg_03.png
// module id = 0J3k
// module chunks = 1